
import Vue from "vue";
import { IDataTableColumn } from "winfakt-vue-components";
import { Ticket } from "@/models/ticket";
import { TicketAssignedAdmin } from "@/models/ticket-admin";
import { ticketJsonAndGoKeys } from "@/utils/browse/ticket-keys";
import { Department, getDepartmentName } from "@/utils/department";
import { TicketStatus, getTicketStatusName } from "@/utils/ticket-status";
import { toPrettyPlanningString } from "@/utils/strings";
import {TicketService} from "@/services/ticket-service";
import AppFetchingSpinnerOverlay from "@/components/FetchingSpinnerOverlay.vue";
import {Tier, tierToString} from "@/utils/tier";

export default Vue.extend({
	props: {
		tickets: {
			type: Array as () => Ticket[],
			required: true
		},
		selected: {
			type: Array as () => Ticket[],
			required: true
		},
		order: {
			type: String,
			required: true
		},
		orderAscending: {
			type: Boolean
		},
		isFetching: {
			type: Boolean
		}
	},
	computed: {
		orderedColumnProperty(): string {
			for (let key of Object.keys(ticketJsonAndGoKeys)) {
				if (ticketJsonAndGoKeys[key] == this.order) {
					return key;
				}
			}
			return "this.ID";
		},
		// eslint-disable-next-line max-lines-per-function
		columns(): IDataTableColumn[] {
			let _this = this;
			let res = [
				{
					name: "",
					property: "ticketStatus",
					width: "40px",
					disableSorting: true,
					async click(item: Ticket) {
						if(item.isPinned()){
							await TicketService.unpin(item);
							_this.$emit("refresh");
						}
					},
				},
				{
					name: "NR",
					property: "id",
					width: "80px",
					click(item: Ticket) {
						_this.openTicket(item);
					},
				},
				{
					name: "Klant",
					property: "company.name",
					width: "150px"
				},
				{
					name: "Datum",
					property: "timeCreated",
					print(val: Date): string {
						return val.getDate() > 0 ?
							`${val.getDate()}/${val.getMonth()+1}/${val.getFullYear()} ${val.getHours()}:${ val.getMinutes() <= 9 ? "0"+val.getMinutes() :  val.getMinutes() }`
							: "";
					}
				},
				{
					name: "Planning",
					property: "timeSheduled",
					print(val: Date): string {
						return toPrettyPlanningString(val);
					}
				},
				{
					name: "Afdeling",
					property: "departmentId",
					print(val: Department): string {
						return getDepartmentName(val);
					}
				},
				{
					name: "Onderwerp",
					property: "subject",
					width: "350px"
				},
				{
					name: "Status",
					property: "statusId",
					print(val: TicketStatus): string {
						let s = getTicketStatusName(val);
						return "<span class='" + s[0] + "'>" + s[1] + "</span>";
					}
				},
				{
					name: "Prio",
					property: "priority",
					width: "75px",
					print(val: number): string {
						if (val == 1) {
							return "Niet prio";
						} else if (val == 2) {
							return "Prio";
						} else if(val == 3){
							return "<span class='soft-urgent'>Dringend</span>";
						} else if(val == 4){
							return "<span class='urgent'>Prioritair</span>";
						}
						return "";
					}
				},
				{
					name: "Toegewezen",
					property: "assignedAdmins",
					print(val: TicketAssignedAdmin[]): string {
						return val.map(a => {
							if (a.admin) {
								return a.admin.name.split(" ")[0];
							}
							return `${a.adminId}`;
						}).join(", ");
					},

					disableSorting: true
				},
				{
					name: "Packet",
					property: "company.tier",
					print(val:Tier):string{
						return tierToString(val);
					}
				}
			] as IDataTableColumn[];
			return res;
		},

	},
	methods: {
		onOrder({ascending, order}: { ascending: boolean, order: string }):void {
			this.$emit("order", {order: ticketJsonAndGoKeys[order], ascending});
		},
		openTicket(item:Ticket){
			this.$emit("open-ticket", item);
		}
	},
	components: {
		AppFetchingSpinnerOverlay
	}
});
